import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { CharcterOxxo } from "../objects/CharacterOxxo";
import { CameraController } from "../../componets3D/CameraController";
import { MouseEvents } from "../../componets3D/MouseEvents";
import { BreadStation, MapOxxoTopicOne } from "../objects/Topics";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { CubeSelect } from "../objects/CubeSelect";
import { Panecitos } from "../objects/Topics/TopicOne/Panecitos";
import { QueseraOperation } from "../objects/Topics/TopicOne/QueseraOperation";

export class SceneTopicOne extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviro) {
		super();
		this.characterSelected = character;
		this.environment = enviro;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.light()
		this.create();
		this.listeners()
		this.renderAnimations();
	}

	create() {
		this.map = new MapOxxoTopicOne(this.loadingManager);
		this.add(this.map);
		this.add(this.characterSelected)

		this.breadStation = new BreadStation(this.loadingManager)

		this.cubePaso1 = new CubeSelect("paso1", 0xffffff)
		this.cubePaso2 = new CubeSelect("paso2", 0xffffff)
		this.cubePaso3 = new CubeSelect("paso3", 0xffffff)
		this.cubePaso4 = new CubeSelect("paso4", 0xffffff)
		this.cubePaso5 = new CubeSelect("paso5", 0xffffff)
		this.cubePaso6 = new CubeSelect("paso6", 0xffffff)

		this.panecitos = new Panecitos(this.loadingManager)
		this.queseraOperation = new QueseraOperation(this.loadingManager)

	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	SceneInitialState() {

	}

	characterMoveInitScene() {
		this.characterSelected.position.set(-5.9111, -1.8, -4);
		this.characterSelected.rotation.set(0, 0.9998, 0);
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateSaludo();
	}

	cubeActOne() {
		this.cubePaso1.position.set(-14.5101, -0.1059, -7.0676)
		this.cubePaso1.scale.set(0.5, 0.26, 1.07)

		this.cubePaso2.position.set(-14.5101, -0.4008, -7.0676)
		this.cubePaso2.scale.set(0.5, 0.26, 1.07)

		this.cubePaso3.position.set(-14.5101, -0.5852, -7.0676)
		this.cubePaso3.scale.set(0.5, 0.26, 1.07)

		this.cubePaso4.position.set(-14.5101, -0.7767, -7.0676)
		this.cubePaso4.scale.set(0.5, 0.26, 1.07)

		this.cubePaso5.position.set(-14.5101, -0.9948, -7.0676)
		this.cubePaso5.scale.set(0.5, 0.26, 1.07)

		this.cubePaso6.position.set(-14.5101, -0.5509, -7.0676)
		this.cubePaso6.scale.set(0.5, 1.14, 1.07)

	}
	cubeHiddenAll() {
		this.cubePaso1.visible = false
		this.cubePaso1.clearAnimation()

		this.cubePaso2.visible = false
		this.cubePaso2.clearAnimation()

		this.cubePaso3.visible = false
		this.cubePaso3.clearAnimation()

		this.cubePaso4.visible = false
		this.cubePaso4.clearAnimation()

		this.cubePaso5.visible = false
		this.cubePaso5.clearAnimation()

		this.cubePaso6.visible = false
		this.cubePaso6.clearAnimation()

	}

	resetActOne() {
		this.cubeHiddenAll()
	}

	sceneActivityOneState() {
		this.characterMoveInitScene()

		this.map.Pan_dulce.visible = false

		this.breadStation.position.set(-14.5842, -1.5118, -7.0663)
		this.breadStation.rotation.y = 1.5512
		this.add(this.breadStation)

		this.cubeActOne()
		this.cubeHiddenAll()
		this.add(this.cubePaso1, this.cubePaso2, this.cubePaso3, this.cubePaso4, this.cubePaso5, this.cubePaso6)

		ObserverEmitter.on(EVENTS.tema3.actOne.clickBread, (step = "") => {
			this.mouseEvents.disposeInteractions();
			this.mouseEvents.objectsToValue = [];

			this.cubeHiddenAll()
			switch (step) {
				case "cubepaso1":
					this.cubePaso1.visible = true
					this.cubePaso1.onAnimationOpacity()
					this.mouseEvents.objectsToValue = [this.cubePaso1];
					break;

				case "cubepaso2":
					this.breadStation.onChangueTextureVitrina(this.breadStation.nameTexture.p2)
					this.cubePaso2.visible = true
					this.cubePaso2.onAnimationOpacity()
					this.mouseEvents.objectsToValue = [this.cubePaso2];
					break;

				case "cubepaso3":
					this.breadStation.onChangueTextureVitrina(this.breadStation.nameTexture.p3)
					this.cubePaso3.visible = true
					this.cubePaso3.onAnimationOpacity()
					this.mouseEvents.objectsToValue = [this.cubePaso3]
					break;

				case "cubepaso4":
					this.breadStation.onChangueTextureVitrina(this.breadStation.nameTexture.p4)
					this.cubePaso4.visible = true
					this.cubePaso4.onAnimationOpacity()
					this.mouseEvents.objectsToValue = [this.cubePaso4]
					break;

				case "cubepaso5":
					this.breadStation.onChangueTextureVitrina(this.breadStation.nameTexture.p5)
					this.cubePaso5.visible = true
					this.cubePaso5.onAnimationOpacity()
					this.mouseEvents.objectsToValue = [this.cubePaso5]
					break;

				case "cubepaso6":
					// this.cubePaso6.helpers()
					this.cubePaso6.visible = true
					this.cubePaso6.onAnimationOpacity()
					this.mouseEvents.objectsToValue = [this.cubePaso6]
					break;

				default:
					this.resetActOne()
					break;
			}
			this.mouseListeners();
		});

	}

	sceneActivityTwoState() {
		this.characterMoveInitScene()

		this.panecitos.position.set(-5.9111, -1.6265, -3.4996);
		this.panecitos.rotation.set(1.3308, 0.669, -1.316);
		this.panecitos.Cuernito.visible = false
		this.panecitos.Dona.visible = false
		this.panecitos.Panque.visible = false
		// this.panecitos.helpers()
		this.add(this.panecitos)

		ObserverEmitter.on(EVENTS.tema3.actTwo.viewPanes, (check = "") => {
			this.panecitos.Cuernito.visible = false
			this.panecitos.Dona.visible = false
			this.panecitos.Panque.visible = false
			switch (check) {
				case "Cuernito":
					this.panecitos.Cuernito.visible = true
					break;
				case "Dona":
					this.panecitos.Dona.visible = true
					break;
				case "Panque":
					this.panecitos.Panque.visible = true
					break;

				default:
					break;
			}
		})

	}

	sceneActivityFourState() {
		this.characterMoveInitScene()

		this.mouseEvents.disposeInteractions()

		this.map.Bitz.visible = false

		this.queseraOperation.position.set(-7.8456, -1.5308, -10.2208)
		this.queseraOperation.onChangueTextureBag(0)
		this.map.Puerta.material.opacity = 1
		this.queseraOperation.Blitz_Tapa_Frontal.material.opacity = 1
		this.queseraOperation.Bitz_Separador.material.opacity = 1
		this.queseraOperation.Dispensador.material.opacity = 1
		this.queseraOperation.Tapon_Bolsa.material.opacity = 1
		this.queseraOperation.setPositionChild()
		this.queseraOperation.visible = true
		this.add(this.queseraOperation)

		ObserverEmitter.on(EVENTS.tema3.actFour.moveCamarePosition, (position = "") => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			switch (position) {
				case "quesera":
					this.camera.moveCameraToPoint(new Vector3(-7.2954, 0.0247, -8.4726), 1, new Vector3(-7.853, -1.372, -10.998), () => {
						// this.camera.control.enableRotate = true;
						// this.camera.control.enablePan = true;
						// this.camera.helper()
						// this.camera.control.enableZoom = false
					})
					break;
				case "bathroom":
					this.camera.moveCameraToPoint(new Vector3(-7.3017, 0.0776, 8.144), 2, new Vector3(-4.484, -0.7, 8.451), () => {
						this.camera.moveCameraToPoint(new Vector3(4.8502, 0.6691, 10.368), 2, new Vector3(7.633, -0.266, 10.504), () => {

							this.map.onAnimationOpacity(this.map.Puerta, () => {
								this.camera.moveCameraToPoint(new Vector3(13.5991, 0.503, 9.4042), 2, new Vector3(13.522, -0.568, 6.668), () => {
									this.camera.moveCameraToPoint(new Vector3(15.0455, 0.4331, 0.577), 2, new Vector3(12.926, -0.813, 2.187), () => {
										this.queseraOperation.Quesera_Bolsa.position.set(10.2129, 0.0907, 6.3254)
										this.queseraOperation.Quesera_Bolsa.rotation.set(1.6485, 0.4712, -2.106)
										ObserverEmitter.emit(EVENTS.tema3.actFour.finishMoveAnimation, "bathroom")
									})
								})
							})

						})
					})
					break;
				case "quesera_nueva":
					this.queseraOperation.onChangueTextureBag(1)
					this.camera.moveCameraToPoint(new Vector3(14.1301, 0.109, 9.7587), 2, new Vector3(11.406, -0.979, 9.583), () => {
						this.camera.moveCameraToPoint(new Vector3(-7.7007, 0.4015, 9.1375), 2, new Vector3(-7.548, -0.664, 6.403), () => {
							this.camera.moveCameraToPoint(new Vector3(-7.2954, 0.0247, -8.4726), 1, new Vector3(-7.853, -1.372, -10.998), () => {
								this.queseraOperation.Quesera_Bolsa.position.set(-0.1627, 0.4354, 0.2204)
								this.queseraOperation.Quesera_Bolsa.rotation.set(-1.8, 3.2054, -3.1907)

								this.queseraOperation.Tapon_Bolsa.material.opacity = 1
								this.queseraOperation.Tapon_Bolsa.position.set(-0.0261, 0.5088, 0.2743)
								this.queseraOperation.Tapon_Bolsa.rotation.x = -0.2132

								ObserverEmitter.emit(EVENTS.tema3.actFour.finishMoveAnimation, "quesera_nueva")
							})
						})
					})
					break;
				default:
					break;
			}
		})

		ObserverEmitter.on(EVENTS.tema3.actFour.animationObjecs, (step = "") => {
			switch (step) {
				case "tapa_quesera":
					this.queseraOperation.onAnimationMovePosition(
						this.queseraOperation.Blitz_Tapa_Frontal,
						{ x: 0, y: 0.2929, z: 0 },
						1,
						() => {
							this.queseraOperation.onOpacityObject(this.queseraOperation.Blitz_Tapa_Frontal, 2, 0,
								() => {
									ObserverEmitter.emit(EVENTS.tema3.actFour.finishMoveAnimation, "remove_cover")
								})
						})
					break;

				case "quitar_bolsa":
					this.queseraOperation.onOpacityObject(this.queseraOperation.Bitz_Separador, 2, 0,
						() => {
							this.queseraOperation.onOpacityObject(this.queseraOperation.Dispensador, 2, 0,
								() => {
									this.queseraOperation.onOpacityObject(this.queseraOperation.Tapon_Bolsa, 2, 0,
										() => {
											this.queseraOperation.onAnimationMovePosition(this.queseraOperation.Quesera_Bolsa, { x: 0, y: 0.6631, z: 0.535 }, 2)
											this.queseraOperation.onAnimationMoveRotation(this.queseraOperation.Quesera_Bolsa, { x: -1.7571, y: 0, z: 0 }, 2, () => {
												ObserverEmitter.emit(EVENTS.tema3.actFour.moveCamarePosition, "bathroom")
											})
										})
								})
						})
					break;

				case "poner_valvula":
					this.queseraOperation.onAnimationMovePosition(this.queseraOperation.Tapon_Bolsa, { x: -0.16, y: 0.54, z: 0.31 }, 2)
					this.queseraOperation.onAnimationMoveRotation(this.queseraOperation.Tapon_Bolsa, { x: 1.6615, y: 0, z: 0 }, 2)

					this.queseraOperation.onAnimationMovePosition(this.queseraOperation.Quesera_Bolsa, { x: -0.1615, y: 0.2958, z: 0.3078 }, 2)
					this.queseraOperation.onAnimationMoveRotation(this.queseraOperation.Quesera_Bolsa, { x: 0, y: 0, z: 0 }, 2,
						() => {
							ObserverEmitter.emit(EVENTS.tema3.actFour.finishMoveAnimation, "poner_valvula")
						})
					break;

				case "terminar_proceso":
					this.queseraOperation.onAnimationMovePosition(this.queseraOperation.Tapon_Bolsa, { x: 0, y: 0.2418, z: 0.0022 }, 2)
					this.queseraOperation.onAnimationMovePosition(this.queseraOperation.Quesera_Bolsa, { x: 0, y: 0, z: 0 }, 2,
						() => {
							this.queseraOperation.onOpacityObject(this.queseraOperation.Dispensador, 2, 1,
								() => {
									this.queseraOperation.onOpacityObject(this.queseraOperation.Bitz_Separador, 2, 1,
										() => {
											this.queseraOperation.onOpacityObject(this.queseraOperation.Blitz_Tapa_Frontal, 2, 1,
												() => {
													this.queseraOperation.onAnimationMovePosition(this.queseraOperation.Blitz_Tapa_Frontal, { x: 0, y: 0, z: 0 }, 2,
														() => {
															ObserverEmitter.emit(EVENTS.tema3.actFour.finishMoveAnimation, "terminar_proceso")
														})
												})
										})
								})
						})
					break;
				default:
					break;
			}
		})

	}

	listeners() {
		ObserverEmitter.on(EVENTS.tema3.actOne.moveBread, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-12.2681, 0.1011, -7.0912), 1, new Vector3(-14.958, -1.083, -7.121), () => {

			})
		});
	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-12.4058, -0.5368, 4.338), 2, new Vector3(-11.992, -1.74, -9.102), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 13.5;
					this.camera.control.maxDistance = 13.5;
					this.camera.control.enablePan = false;

					this.activeAudio()

				})
				break;
			case 1:
				//* posicion panes
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = 4;
					this.camera.control.minAzimuthAngle = -1.67;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false

					this.activeAudio()

					this.sceneActivityOneState();
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = 4;
					this.camera.control.minAzimuthAngle = -1.67;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false
					this.activeAudio()

					this.sceneActivityTwoState()
				});
				break;
			case 3:
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = 4;
					this.camera.control.minAzimuthAngle = -1.67;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false

					this.activeAudio()

					this.characterMoveInitScene()
				});
				break;
			case 4:
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = 4;
					this.camera.control.minAzimuthAngle = -1.67;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false

					this.activeAudio()

					this.sceneActivityFourState()
				});
				break;
			case 5:
				this.camera.moveCameraToPoint(new Vector3(-4.2751, -1.3041, -3.0297), 1, new Vector3(-6.81, -1.86, -4.409), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.maxAzimuthAngle = 4;
					this.camera.control.minAzimuthAngle = -1.67;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enableRotate = false;
					this.camera.control.enablePan = false;
					this.camera.control.enableZoom = false

					this.activeAudio()

					this.characterMoveInitScene()
				});
				break;
			default:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;

					this.characterSelected.visible = false

				});
				break;
		}
	}

	mouseListeners() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name;
				ObserverEmitter.emit(EVENTS.tema3.listenClick, name);
			}
		});
	}

	renderAnimations(delta) {
	}
}
